import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useRef } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import { Controller, useForm } from 'react-hook-form';
import { Button, Divider, Modal, CardContent, Stack, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import MainCard from 'components/MainCard';
import { getAttentionObservationsById, getEquipmentAlertsById, patchAttentionObservationsRelease } from 'components/axios/equipmentAlertsAxios';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { useEnumApi } from 'contexts/EnumApiContext';
import { LoadingButton } from '@mui/lab';
import FileDownloadIcon from 'components/FileDownloadIcon';
import CustomDatePicker from 'components/date_picker/CustomDatePicker';
import { useSelector } from "react-redux";
import { ROLE } from 'data/data';
import { customFileAxios } from 'components/axios/customAxios';

const AttentionObservationRequestLayer = ({alertId, setIsLoading : setParentIsLoading, type, isOpen=false}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    const { name } = useSelector(state => state.user);
    const { role } = useEnumApi();

    const [open, setOpen] = useState(isOpen);
    const handleOpen = () => {setOpen(true); setIsLoading(false)};
    const handleClose = () => setOpen(false);

     // modal 관련
     const { openModal } = useModals();
     let [alertMessage, setAlertMessage] = useState('');
     
     const handleAlertClick = () => {
         openModal(modals.alertModal, {
             onClose : () => {
             },
             message: alertMessage,
         });
     };

    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const { control, register , handleSubmit
      , setValue , getValues, setFocus, watch, trigger, formState : { isDirty , errors } } = useForm({});

    // 상황보고 필드 값 감시
    const watchDtl = watch("reportDtl");
    const watchDate = watch("reportYmd");
    const watchReporter = watch("reportUser");

    const [isReleaseMode, setIsReleaseMode] = useState(false);

    const [equipmentAlert, setEquipmentAlert] = useState(null);
    const [attentionObservation, setAttentionObservation] = useState(null);
    const [observeStatus, setObserveStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);

    const nextID = useRef(1);
    const [inputFiles, setInputFiles] = useState([]);

    const today = new Date();
    const todayNum = dayjs(today).format("YYYYMMDD");

    useEffect(() =>{
      if (alertId)
        getAttentionObservation();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[alertId, isLoading]);

    const getAttentionObservation = () => {
      Promise.all([
        getEquipmentAlertsById(alertId).then((data)=>{
          setEquipmentAlert(data);
          return data;
        })
      ]).then((res)=>{
        if (res != null && res[0] != null && res[0].atentObserv != null) {
          getAttentionObservationsById(res[0]?.atentObserv?.id).then((data2)=>{
            return data2;
          }).then((res2)=>{
            if (res2) {
              setAttentionObservation(res2);
              if (res2.status) {
                setObserveStatus(getEnumValueByEnumNameAndCode("AttentionObservationStatus", res2.status)?.[0]?.title)
              }
              // if (res2.endYmd) {
              //   let endYmd = res2.endYmd.replaceAll('-','');
              //   if (endYmd >= todayNum) {  // 유효
              //     setObserveStatus(t('message.common.text.available'));
              //   } else {
              //     setObserveStatus(t('message.common.text.release'));
              //   }
              // } else {
              //   setObserveStatus(t('message.common.text.available'));
              // }
              setValue("plannedEndYmd",(res2.plannedEndYmd || null));
              setValue("remark",(res2.remark || null));
              setValue("regUser",(res2.regUser || name || null));
              setValue("regYmd",(res2.regYmd || dayjs(new Date()).format('YYYY-MM-DD')));
              // setValue("risUser",(res2.risUser || name || null));
              setValue("risUser",(res2.risUser || null));
              setValue("risYmd",(res2.risYmd || null));

              if (res2.statusReport) {
                setValue("reportDtl",(res2.statusReport?.reportDtl || null));
                setValue("reportUser",(res2.statusReport?.reportUser || null));
                setValue("reportYmd",(res2.statusReport?.reportYmd || null));
                
                if (res2.statusReport.reportFiles) {
                  let inputFilesCopy = [];
                  nextID.current = 1;
                  for (var j=0;j<res2.statusReport.reportFiles.length;j++) {
                      const input = {	
                          id: nextID.current,
                          file: {},
                          rFile: res2.statusReport.reportFiles[j],
                      };
                      inputFilesCopy = [...inputFilesCopy, input]
                      nextID.current += 1;
                  }
                  setInputFiles(inputFilesCopy);
                }
              } else {
                setValue("reportYmd",null);
              }
            } else {
              setValue("regUser",(name || null));
              setValue("regYmd",(dayjs(new Date()).format('YYYY-MM-DD')));
              // setValue("risUser",(name || null));
            }
          })
        } else {
          setValue("regUser",(name || null));
          setValue("regYmd",(dayjs(new Date()).format('YYYY-MM-DD')));
          // setValue("risUser",(name || null));
        }
        setIsLoading(true);
      })
    }

    function addInputFile(file) {
      const input = {	
          id: nextID.current,
          file: {},
          rFile: file,
      };

      setInputFiles([...inputFiles, input]);
      nextID.current += 1;
    }

    // 삭제
    function deleteInputFile(index) {
        setInputFiles(inputFiles.filter(item => item.id !== index));
    }

    function handleInputFileChange(e, index) {
        if (index > inputFiles.length) return;
        
        let inputFilesCopy = [...inputFiles];
        inputFilesCopy[index].file = e.target.files[0];
        inputFilesCopy[index].rFile = null;
        setInputFiles(inputFilesCopy);
    }

    const hasAnyValue = watchDtl || watchDate || watchReporter || (inputFiles && inputFiles.length > 0);
    const onSubmit = (data, e) => {
      setFileLoading(true);
      if (data.plannedEndYmd === null || data.plannedEndYmd === '') {
        alertMessage = t('message.common.alert.observe.endYmd.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
      if (data.plannedEndYmd != null && data.plannedEndYmd != '' && !regexDate.test(data.plannedEndYmd)) {
        alertMessage = t('message.common.alert.observe.endYmd.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }

      if (data.regYmd === null || data.regYmd === '') {
        alertMessage = t('message.common.alert.observe.startYmd.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
      if (data.regYmd != null && data.regYmd != '' && !regexDate.test(data.regYmd)) {
        alertMessage = t('message.common.alert.observe.startYmd.input');
        setAlertMessage(alertMessage);
        handleAlertClick();
        setFileLoading(false);
        return;
      }
    
      let dto = {
        equipmentAlert : {id:alertId},
        equipment : {id:equipmentAlert.equipment.id},
        plannedEndYmd : data.plannedEndYmd,
        regUser : data.regUser,
        regYmd : data.regYmd,
        remark : data.remark,
      }

      let statusReport = {
        "reportDtl" : data.reportDtl,
        "reportUser" : data.reportUser,
        "reportYmd" : data.reportYmd,
      }
      dto.statusReport = statusReport;
console.log(dto)
      let formData = new FormData();
      let fileCnt = 0;
      if(inputFiles) {
        for (var l=0;l<inputFiles.length;l++) {
            if (inputFiles[l].file && inputFiles[l].file.name) {
                formData.append("statusFiles", inputFiles[l].file);
                fileCnt++;
            }
        }
      }

      let rfileCnt = 0;
      if (inputFiles) {
        let rFiles = [];
        for (var a2=0;a2<inputFiles.length;a2++) {
            if (inputFiles[a2].rFile && inputFiles[a2].rFile.id) {
                rFiles.push({id : inputFiles[a2].rFile.id});
                rfileCnt++;
            }
        }
        statusReport.reportFiles = rFiles;
      }

      if (data.reportYmd || data.reportUser || data.reportDtl || (fileCnt + rfileCnt) > 0) {
        if (data.reportDtl === null || data.reportDtl === undefined || data.reportDtl === '') {
          alertMessage = t('message.common.alert.status.report.detail.input');
          setAlertMessage(alertMessage);
          handleAlertClick();
          setFileLoading(false);
          return;
        }
        if ((fileCnt + rfileCnt) === 0) {
          alertMessage = t('message.common.alert.status.report.file.write');
          setAlertMessage(alertMessage);
          handleAlertClick();
          setFileLoading(false);
          return;
        }
        if (data.reportUser === null || data.reportUser === undefined || data.reportUser === '') {
          alertMessage = t('message.common.alert.status.reporter.input');
          setAlertMessage(alertMessage);
          handleAlertClick();
          setFileLoading(false);
          return;
        }
        if (data.reportYmd === null || data.reportYmd === undefined || data.reportYmd === '') {
          alertMessage = t('message.common.alert.status.report.date.input');
          setAlertMessage(alertMessage);
          handleAlertClick();
          setFileLoading(false);
          return;
        }

        if (data.reportYmd != null && data.reportYmd != '' && !regexDate.test(data.reportYmd)) {
          alertMessage = t('message.common.alert.status.report.date.input');
          setAlertMessage(alertMessage);
          handleAlertClick();
          setFileLoading(false);
          return;
        }
      }
      
      if(type === undefined && (observeStatus === '' || observeStatus === t('message.common.text.available'))) {  // 등록
        formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

        openModal(modals.confirmModal, {
          onSubmit : (value) => {
            try {
                const res = customFileAxios.post(`/api/attentionObservations`, formData).then((res)=>{
                    //console.log(res);
                    alertMessage = t('message.common.alert.write.done');
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                    setFileLoading(false);
                    setParentIsLoading(false);
                    handleClose();
                    //navigate('../modify/'+res.data.id+window.location.search);
                }).catch((err)=>{
                    console.log(err);
                    setFileLoading(false);
                    if (!err.response?.data?.message) {
                        alertMessage = err.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    } else if (err.response.data.message) {
                        alertMessage = err.response.data.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    }
                });
                // return res.data;
            } catch (error) {
                console.error("error:", error);
                throw error;
            }
            
            // axios({
            //   method: "post",
            //   url: process.env.REACT_APP_API_URL+"/api/attentionObservations",
            //   data: formData,
            //   headers : {
            //       'Content-type' : 'multipart/form-data',
            //       accept : 'application/json,',
            //       'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
            //       'Accept-Language' : t('locale')
            //   }
            // }).then((res)=>{
            //     alertMessage = t('message.common.alert.write.done');
            //     setAlertMessage(alertMessage);
            //     handleAlertClick();
            //     setFileLoading(false);
            //     setParentIsLoading(false);
            //     handleClose();
            // }).catch((err)=>{
            //     console.log(err);
            //     setFileLoading(false);
            //     if (!err.response?.data?.message) {
            //         alertMessage = err.message;
            //         setAlertMessage(alertMessage);
            //         handleAlertClick();
            //     } else if (err.response.data.message) {
            //         alertMessage = err.response.data.message;
            //         setAlertMessage(alertMessage);
            //         handleAlertClick();
            //     }
            // });
          },
          onClose : () => {
              console.log('close');
              setFileLoading(false);
          },
          message: t('message.common.alert.write.question'),
        });
      }

      if (role === ROLE.SA.code || role === ROLE.WA.code) {
        if((type && type === "modify") && observeStatus === t('message.common.text.available')) {  // 수정
          dto.id = attentionObservation.id;
          statusReport.id = attentionObservation.statusReport?.id;

          // console.log(dto);
          formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
          // for (var value2 of formData.entries()) {
          //   console.log(value2[0]+', ',value2[1]);
          // }
          openModal(modals.confirmModal, {
            onSubmit : (value) => {
              try {
                const res = customFileAxios.patch(`/api/attentionObservations/${attentionObservation.id}`, formData).then((res)=>{
                    //console.log(res);
                    alertMessage = t('message.common.alert.modify.done');
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                    setParentIsLoading(false);
                    setFileLoading(false);
                    handleClose();
                    //navigate('../modify/'+res.data.id+window.location.search);
                }).catch((err)=>{
                    console.log(err);
                    setFileLoading(false);
                    if (!err.response?.data?.message) {
                        alertMessage = err.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    } else if (err.response.data.message) {
                        alertMessage = err.response.data.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    }
                });
                // return res.data;
              } catch (error) {
                  console.error("error :", error);
                  throw error;
              }
            
              // axios({
              //   method: "patch",
              //   url: process.env.REACT_APP_API_URL+"/api/attentionObservations/"+attentionObservation.id,
              //   data: formData,
              //   headers : {
              //       'Content-type' : 'multipart/form-data',
              //       accept : 'application/json,',
              //       'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
              //       'Accept-Language' : t('locale')
              //   }
              // }).then((res)=>{
              //     alertMessage = t('message.common.alert.modify.done');
              //     setAlertMessage(alertMessage);
              //     handleAlertClick();
              //     setParentIsLoading(false);
              //     setFileLoading(false);
              //     handleClose();
              // }).catch((err)=>{
              //     console.log(err);
              //     setFileLoading(false);
              //     if (!err.response?.data?.message) {
              //         alertMessage = err.message;
              //         setAlertMessage(alertMessage);
              //         handleAlertClick();
              //     } else if (err.response.data.message) {
              //         alertMessage = err.response.data.message;
              //         setAlertMessage(alertMessage);
              //         handleAlertClick();
              //     }
              // });
            },
            onClose : () => {
                console.log('close');
                setFileLoading(false);
            },
            message: t('message.common.alert.modify.question'),
          });
        }

        if((type && type === "modify") && observeStatus === t('message.common.text.release')) {  // 수정(상황보고파일만)
          delete dto.equipment;
          delete dto.equipmentAlert;
          delete dto.plannedEndYmd;
          delete dto.regUser;
          delete dto.regYmd;
          delete dto.remark;

          dto.id = attentionObservation.id;
          statusReport.id = attentionObservation.statusReport?.id;

          formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
          
          openModal(modals.confirmModal, {
            onSubmit : (value) => {
              try {
                const res = customFileAxios.patch(`/api/attentionObservations/${attentionObservation.id}`, formData).then((res)=>{
                    //console.log(res);
                    alertMessage = t('message.common.alert.modify.done');
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                    setParentIsLoading(false);
                    setFileLoading(false);
                    handleClose();
                    //navigate('../modify/'+res.data.id+window.location.search);
                }).catch((err)=>{
                    console.log(err);
                    setFileLoading(false);
                    if (!err.response?.data?.message) {
                        alertMessage = err.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    } else if (err.response.data.message) {
                        alertMessage = err.response.data.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    }
                });
                // return res.data;
              } catch (error) {
                  console.error("error :", error);
                  throw error;
              }
              
              // axios({
              //   method: "patch",
              //   url: process.env.REACT_APP_API_URL+"/api/attentionObservations/"+attentionObservation.id,
              //   data: formData,
              //   headers : {
              //       'Content-type' : 'multipart/form-data',
              //       accept : 'application/json,',
              //       'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
              //       'Accept-Language' : t('locale')
              //   }
              // }).then((res)=>{
              //     alertMessage = t('message.common.alert.modify.done');
              //     setAlertMessage(alertMessage);
              //     handleAlertClick();
              //     setParentIsLoading(false);
              //     setFileLoading(false);
              //     handleClose();
              // }).catch((err)=>{
              //     console.log(err);
              //     setFileLoading(false);
              //     if (!err.response?.data?.message) {
              //         alertMessage = err.message;
              //         setAlertMessage(alertMessage);
              //         handleAlertClick();
              //     } else if (err.response.data.message) {
              //         alertMessage = err.response.data.message;
              //         setAlertMessage(alertMessage);
              //         handleAlertClick();
              //     }
              // });
            },
            onClose : () => {
                console.log('close');
                setFileLoading(false);
            },
            message: t('message.common.alert.modify.question'),
          });
        }
      }
    }

    const observationClear = async () => {
      setIsReleaseMode(true); // 필수 필드 활성화
      setTimeout(async () => {
        const valid = await trigger(["risUser", "risYmd"]); // 해당 필드만 검증
        // console.log(valid)
        setIsReleaseMode(false); 

        if (valid) {
          openModal(modals.confirmModal, {
            onSubmit : (value) => {
              let risUser = getValues("risUser");
              let risYmd = getValues("risYmd");

              if(risUser === null || risUser === undefined || risUser.trim() === '') {
                alertMessage = t('message.common.alert.observe.release.handler.input');
                setAlertMessage(alertMessage);
                handleAlertClick();
                setValue("risUser",'');
                setFocus("risUser");
                return;
              }

              if(risYmd === null || risYmd === undefined || risYmd.trim() === '') {
                alertMessage = t('message.common.alert.observe.release.date.input');
                setAlertMessage(alertMessage);
                handleAlertClick();
                setValue("risYmd",'');
                setFocus("risYmd");
                return;
              }

              if (risYmd != null && risYmd != '' && !regexDate.test(risYmd)) {
                alertMessage = t('message.common.alert.observe.release.date.input');
                setAlertMessage(alertMessage);
                handleAlertClick();
                setValue("risYmd",'');
                setFocus("risYmd");
                return;
              }

              const body = {
                id : attentionObservation.id,
                risUser : risUser
              };

              patchAttentionObservationsRelease(attentionObservation.id, body).then((res)=>{
                setIsLoading(false);
                setParentIsLoading(false);
                alertMessage = t('message.common.alert.observe.release.complete');
                setAlertMessage(alertMessage);
                handleAlertClick();
              });
            },
            onClose : () => {
                console.log('close');
                setIsReleaseMode(false);
            },
            message: t('message.common.alert.observe.release.handler.question'),
          });
        }
      }, 0);
    }

    if (equipmentAlert) {
      return (
      <>
        {type && type === 'icon' &&
        <Button variant="contained" onClick={handleOpen} style={{padding:"3px", minWidth:"unset"}} color="grey">
          <span className="icon_png" style={{color:"#fff"}}><img src={`${process.env.PUBLIC_URL}/img/icon/content_paste_search.png`} alt='' /></span>
        </Button>
        }
        {((type && type === "modify") || (type === undefined && observeStatus === '')) &&
        <Button variant="contained" onClick={handleOpen} style={{backgroundColor:'#e7c748'}} >
          {type && type==="modify" ? t('message.common.btn.observe.management'):t('message.common.btn.observe')}
        </Button>
        }
  
        <Modal className="pop_box pop_box2 pop_box3" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard title={t('message.common.btn.observe')} modal darkTitle content={false}>
            <div style={{marginTop:"-40px", marginRight:"12px", textAlign:"right"}}>
              <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                {t('message.common.btn.close')}
              </Button>
            </div>
            <CardContent>
              <TableContainer>
                <form onSubmit={handleSubmit(onSubmit)}>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width pop_table view_table">
                  <TableBody>
                    {/* <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.subwayline')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.station && equipmentAlert.equipment.station.workingPart
                       && equipmentAlert.equipment.station.workingPart.subwayLine && getEnumValueByEnumNameAndCode("SubwayLine", equipmentAlert.equipment.station.workingPart.subwayLine) && getEnumValueByEnumNameAndCode("SubwayLine", equipmentAlert.equipment.station.workingPart.subwayLine)[0].title}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.workingPart')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.station && equipmentAlert.equipment.station.workingPart && equipmentAlert.equipment.station.workingPart.name}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.station')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.station && equipmentAlert.equipment.station.name}</TableCell>
                    </TableRow> */}
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level1')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && equipmentAlert.equipment.equipmentCtgr.parent && equipmentAlert.equipment.equipmentCtgr.parent.parent && equipmentAlert.equipment.equipmentCtgr.parent.parent.name}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level2')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && equipmentAlert.equipment.equipmentCtgr.parent && equipmentAlert.equipment.equipmentCtgr.parent.name}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.level3')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && equipmentAlert.equipment.equipmentCtgr.name}</TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.name')}</TableCell>
                      <TableCell colSpan="3" className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.name}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.equipment.number')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.equipment && equipmentAlert.equipment.equipmentNo}</TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.alertedAt')}</TableCell>
                      <TableCell colSpan="3" className="view_td">{equipmentAlert && dayjs(equipmentAlert.latestAlertedAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.alertType')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.alertType && getEnumValueByEnumNameAndCode("AlertType", equipmentAlert.alertType) && getEnumValueByEnumNameAndCode("AlertType", equipmentAlert.alertType)[0].title}</TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.alertCategory')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", equipmentAlert.alertCategory) && getEnumValueByEnumNameAndCode("AlertCategory", equipmentAlert.alertCategory)[0].title}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.alertDetail')}</TableCell>
                      <TableCell colSpan="3" className="view_td_left">{equipmentAlert && equipmentAlert.alertDtl}</TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.constantInspection.checkedAt')}</TableCell>
                      <TableCell colSpan="3" className="view_td">{equipmentAlert && dayjs(equipmentAlert.fieldChkedAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.constantInspection.confirm.user')}</TableCell>
                      <TableCell className="view_td">{equipmentAlert && equipmentAlert.fieldChkUser}</TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.fllwActionType')}</TableCell>
                      <TableCell colSpan="5">
                        {equipmentAlert && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType) && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)[0].title}
                      </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.observe.endYmd')} *</TableCell>
                      <TableCell colSpan="5" className="view_td_left">
                        {observeStatus === t('message.common.text.release') ? 
                        <div>{attentionObservation.endYmd}</div> : 
                        <>
                        <Controller
                            control={control}
                            name="plannedEndYmd"
                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDatePicker
                              field={field} ref={ref} name={name} value={value} register={register} 
                              fieldState={fieldState}
                              requiredMessage={t('message.common.error.text.observe.endYmd.input')}
                            />
                            )}
                        />
                        {errors.plannedEndYmd && <small role="alert"><br></br>{errors.plannedEndYmd.message}</small>}
                        </>
                        }
                      </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.observe.detail')} *</TableCell>
                      <TableCell colSpan="5" className="view_td_left">
                        {observeStatus === t('message.common.text.release') ? 
                        <div>{attentionObservation.remark}</div> : 
                        <>
                        <TextField style={{width:"98%"}} id="outlined-basic" 
                            aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                            {...register("remark", {
                                required : t('message.common.error.text.observe.detail.input')
                            })} 
                            multiline
                            rows={4}
                            sx={{ minWidth: '90%' }} />
                        {errors.remark && <small role="alert"><br></br>{errors.remark.message}</small>}
                        </>
                        }
                      </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.observe.write.date')} *</TableCell>
                      <TableCell className="view_td_left" colSpan="2">
                      {observeStatus === t('message.common.text.release') ? 
                        <div>{attentionObservation.regYmd}</div> : 
                        <>
                        <Controller
                            control={control}
                            name="regYmd"
                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDatePicker
                              field={field} ref={ref} name={name} value={value} register={register} 
                              fieldState={fieldState}
                              requiredMessage={t('message.common.error.text.observe.write.date.input')}
                            />
                            )}
                        />
                        {errors.regYmd && <small role="alert"><br></br>{errors.regYmd.message}</small>}
                        </>
                        }
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.observe.writer')} *</TableCell>
                      <TableCell colSpan="2" className="view_td_left">
                      {observeStatus === t('message.common.text.release') ? 
                        <div>{attentionObservation.regUser}</div> : 
                        <>
                        <TextField id="outlined-basic" 
                            aria-invalid={!isDirty ? undefined : errors.regUser ? "true" : "false"}
                            defaultValue={attentionObservation && (attentionObservation.regUser || '')}
                            {...register("regUser", {
                                required : t('message.common.error.text.observe.writer.input')
                            })} />
                        {errors.regUser && <small role="alert"><br></br>{errors.regUser.message}</small>}
                        </>
                      }
                      </TableCell>
                    </TableRow>
                    {observeStatus && 
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.release.handler')}</TableCell>
                      <TableCell colSpan="2" className="view_td_left">
                        {observeStatus === t('message.common.text.release') ? 
                        <div>{attentionObservation.risUser}</div> : 
                        <>
                        <TextField id="outlined-basic" 
                            defaultValue={attentionObservation && (attentionObservation.risUser || '')}
                            {...register("risUser", {
                                // required: isReleaseMode ? t('message.common.alert.observe.release.handler.input') : false
                                validate: (value) =>
                                !isReleaseMode || value ? true : t('message.common.alert.observe.release.handler.input'),
                            })} />
                            {errors.risUser && <small role="alert"><br></br>{errors.risUser.message}</small>}
                        </>
                        }
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.release.date')}</TableCell>
                      <TableCell className="view_td_left" colSpan="2">
                        {observeStatus === t('message.common.text.release') ? 
                        <div>{attentionObservation.risYmd}</div> : 
                        <>
                        <Controller
                            control={control}
                            name="risYmd"
                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDatePicker
                              field={field} ref={ref} name={name} value={value} register={register} 
                              fieldState={fieldState}
                              // requiredMessage={isReleaseMode ? t('message.common.error.text.release.date.input') : false}
                              hasAnyValue={isReleaseMode}
                              validateMessage={t('message.common.alert.observe.release.date.input')}
                            />
                            )}
                        />
                        </>
                        }
                      </TableCell>
                    </TableRow>
                    }
                    {observeStatus &&
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.status')}</TableCell>
                      <TableCell colSpan="5" className='view_td'>
                        <div style={{display:"flex",justifyContent:"space-around",padding:"0 9px"}}>
                          <span>{observeStatus}</span>
                          <span></span>
                          {observeStatus === t('message.common.text.available') &&
                          <Button variant="contained" color="warning" style={{padding:"0 9px", color:"#fff"}}
                            onClick={observationClear}>{t('message.common.subtitle.observe.release')}</Button>
                          }
                        </div>
                      </TableCell>
                    </TableRow>
                    }
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.status.report.detail')}</TableCell>
                      <TableCell colSpan="5" className="view_td_left">
                        <TextField style={{width:"98%"}} id="outlined-basic" 
                            {...register("reportDtl", {
                                validate: (value) =>
                                !hasAnyValue || value ? true : t('message.common.alert.status.report.detail.input'),
                            })} 
                            multiline
                            rows={4}
                            sx={{ minWidth: '90%' }} />
                            {errors.reportDtl && <small role="alert"><br></br>{errors.reportDtl.message}</small>}
                      </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">
                      {t('message.common.subtitle.status.report.file')}
                        <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addInputFile}>+</AddCircleOutlineIcon>
                      </TableCell>
                      <TableCell colSpan="5" className='view_td_left'>
                        {inputFiles && inputFiles.map(function(item, index) {
                          return (
                          <div key={index} style={{display:"flex"}}>
                              <input
                                  type="file"
                                  value={''}
                                  style={{width:"unset"}}
                                  onChange={e => {
                                    handleInputFileChange(e, index);
                                  }}
                              />
                              {(item.file && item.file.name) ? item.file.name : (item.rFile && item.rFile.id && <><FileDownloadIcon file={item.rFile} viewFileName={true} fontColor={'#000'} /></>)}
                              { inputFiles[index] ? (
                                  <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputFile(item.id)}>-</RemoveCircleOutlineIcon>
                              ) : (
                              ''
                              )}
                          </div>
                          )
                          })}
                          {hasAnyValue && inputFiles.length === 0 && (
                            <small role="alert"><br></br>{t('message.common.alert.status.report.file.write')}</small>
                          )}
                        </TableCell>
                    </TableRow>
  
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.status.reporter')}</TableCell>
                      <TableCell>
                        <TextField style={{width:"90%"}} id="outlined-basic" 
                            defaultValue={attentionObservation && attentionObservation.statusReport && (attentionObservation.statusReport.reportUser || '')}
                            {...register("reportUser", {
                                validate: (value) =>
                                !hasAnyValue || value ? true : t('message.common.alert.status.reporter.input'),
                            })} 
                            sx={{ minWidth: '60%' }} />
                            {errors.reportUser && <small role="alert"><br></br>{errors.reportUser.message}</small>}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.status.report.date')}</TableCell>
                      <TableCell className="view_td_left" colSpan="3">
                      <Controller
                            control={control}
                            name="reportYmd"
                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                            <CustomDatePicker
                              field={field} ref={ref} name={name} value={value} register={register} 
                              fieldState={fieldState}
                              hasAnyValue={hasAnyValue}
                              validateMessage={t('message.common.alert.status.report.date.input')}
                            />
                            )}
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                </form>
              </TableContainer>
            </CardContent>
            <Divider />
            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ px: 2.5, py: 2 }}>
              {(type && type === "modify" && (role === ROLE.SA.code || role === ROLE.WA.code)) &&
              <LoadingButton variant="contained" size="small" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.modify')}</LoadingButton>
              }
              {(attentionObservation === null && (observeStatus === '' || observeStatus === t('message.common.text.available'))) &&
              <LoadingButton variant="contained" size="small" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</LoadingButton>
              }
              <Button variant="contained" color="error" size="small" onClick={handleClose}>{t('message.common.btn.cancel')}</Button>
            </Stack>
  
          </MainCard>
        </Modal>
      </>
      )
    }
}

export default AttentionObservationRequestLayer;
